<template>
  <div class="pageContainer">
    <ReportsHomeV2 title="Container Attachment Report" placeholder="Job No" :inputValue.sync="jobNo" :shareContent="shareContent" @generateReport="generateReport" @shareReport="shareReport" ref="mainReport"> </ReportsHomeV2>

    <Loader :isVisible.sync="isLoading" :loadingText="loadingText" :isFullScreen="true" />
    <PopupV2 :type="popupType" :show="showPopup" :title="popupTitle" :content="popupContent" @buttonClicked="showPopup = false"></PopupV2>
  </div>
</template>

<script>
/* eslint-disable */
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';

export default {
  components: {
    ReportsHomeV2
  },
  data: function() {
    return {
      isLoading: false,
      loadingText: '',

      popupType: 'error',
      showPopup: false,
      popupTitle: '',
      popupContent: '',

      jobNo: '',
      jsReportdata: {},
      templateID: 'IOGDOq8Rr',

      shareContent: {},
    }
  },
  props: {
  },
  methods: {
    formatDateTime: function(dateTime, format) {
      if (!dateTime) // if API didn't return a date, dont assign anything
        return; // returning null here would create another field in the data with a null value

      return this.$dateTime.getDateTime(new Date(dateTime), format);
    },
    getJobDetails: async function() {
      let loginDetails = await this.$apiCallV2('/Login/GetDetails');
      try { // call API to get details about job with the specified job number passed in URL query
        var jobDetails = await this.$apiCallV2(`/Report/GetJobDetails?config=${loginDetails.ConfigCode}&userID=${loginDetails.LoginUserId}&jobno=${this.jobNo}&rpt=RptJobContainerAttach`);
      } catch (e) {
        console.log(e);
      }
      
      if (jobDetails.length == 0) { // no job with that job number found
        this.isLoading = false;
        this.showPopup = true;
        this.popupTitle = 'Job Not Found';
        this.popupContent = `No Job with Job No. '${this.jobNo}' found.`;
        return false; // error encountered, return false
      }
      
      jobDetails.JobDetails.Job['companyName'] = loginDetails.CoName; // append company name

      // get user's preferred date format from vuex state
      let preferredDateFormat = this.$store.state['preferredDateFormat'];

      // format all dates that will be displayed on the report to follow the user's preferred date format
      jobDetails.JobDetails.Job['Job Time'] = this.formatDateTime(jobDetails.JobDetails.Job['Job Time'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['Closing Time'] = this.formatDateTime(jobDetails.JobDetails.Job['Closing Time'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['POL ETA'] = this.formatDateTime(jobDetails.JobDetails.Job['POL ETA'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['POL ETD'] = this.formatDateTime(jobDetails.JobDetails.Job['POL ETD'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['POD ETA'] = this.formatDateTime(jobDetails.JobDetails.Job['POD ETA'], `${preferredDateFormat} HH:mm`);
      jobDetails.JobDetails.Job['Final Dest ETA Time'] = this.formatDateTime(jobDetails.JobDetails.Job['Final Dest ETA Time'], `${preferredDateFormat} HH:mm`);

      if (jobDetails.JobDetails.Job['Documents']) {
        for (let doc of jobDetails.JobDetails.Job['Documents'])
          doc['Doc Rec Date'] = this.formatDateTime(doc['Doc Rec Date'], preferredDateFormat); // date only, no time
      }

      if (jobDetails.JobDetails.Job['ContStatus']) {
        for (let contStatus of jobDetails.JobDetails.Job['ContStatus']) {
          contStatus['Request Time'] = this.formatDateTime(contStatus['Request Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Pickup fr Depot Time'] = this.formatDateTime(contStatus['Pickup fr Depot Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Discharge fr Vessel Time'] = this.formatDateTime(contStatus['Discharge fr Vessel Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Gatepass Received Time'] = this.formatDateTime(contStatus['Gatepass Received Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Out fr Port Time'] = this.formatDateTime(contStatus['Out fr Port Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Required Date'] = this.formatDateTime(contStatus['Required Date'], preferredDateFormat); // date only, no time
          contStatus['Delivered Time'] = this.formatDateTime(contStatus['Delivered Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Ready for Collection Time'] = this.formatDateTime(contStatus['Ready for Collection Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Collected Time'] = this.formatDateTime(contStatus['Collected Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Closing Time'] = this.formatDateTime(contStatus['Closing Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Empty to Depot Time'] = this.formatDateTime(contStatus['Empty to Depot Time'], `${preferredDateFormat} HH:mm`);
          contStatus['Laden to Port Time'] = this.formatDateTime(contStatus['Laden to Port Time'], `${preferredDateFormat} HH:mm`);
        }
      }

      // append current time
      jobDetails.JobDetails.Job['timePrinted'] = this.$dateTime.getDateTime(new Date(), `${preferredDateFormat} HH:mm`);

      // rearrange containers in ContStatus to match the order of containers in ContDetail
      if (jobDetails.JobDetails.Job['ContStatus']) {
        let contStatus = jobDetails.JobDetails.Job['ContStatus'];
        let rearrangedContStatus = [];
        for (let contDetail of jobDetails.JobDetails.Job['ContDetail']) {
          let matchingContainer = contStatus.findIndex((element) => { return element['Cont No'].trim() == contDetail['Container No'].trim() })
          if (matchingContainer != -1) { // matching container found
            rearrangedContStatus.push(contStatus[matchingContainer]);
            contStatus.splice(matchingContainer, 1); // remove matching container from contStatus, we dont need to check its Cont No on the next iteration
          }
        }

        // overwrite ContStatus array with the rearranged array
        jobDetails.JobDetails.Job['ContStatus'] = rearrangedContStatus;
      }
      

      this.jsReportdata = jobDetails.JobDetails.Job;
      return true; // no errors, return true
    },
    generateReport: async function() {
      this.isLoading = true;
      this.loadingText = "Getting Job Details";
      if (await this.getJobDetails()) {
        this.loadingText = "Generating Report";
        await this.$refs['mainReport'].generateReport(this.templateID, this.jsReportdata);
        this.shareContent = {
          subject: `Container Attachment Report - ${this.jobNo}`,
          body: `The Container Attachment report for Job ${this.jobNo} is available at {link}`
        }
        this.isLoading = false;
      }
    },
    shareReport: async function() {
      this.isLoading = true;
      this.loadingText = 'Generating Link';

      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      let fileName = `${loginDetails['ConfigCode']}_${loginDetails['LoginUserID']}_ContAttach_${this.jobNo}_${this.$dateTime.getDateTime(new Date(), 'yyyyMMddHHmm')}`;
      await this.$refs['mainReport'].generateShareLink(fileName, loginDetails['ConfigCode']);

      this.isLoading = false;
    },
  },
  async mounted() {
    let jobNo = this.$route.query['jobNo'];
    if (jobNo) {
      this.jobNo = jobNo;
      await this.generateReport();

      setTimeout(() => { // only automatically prints once when loading the page
        this.$refs['mainReport'].printReport(); // clicking generate report won't auto print
      }, 100);
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.pageContainer {
  height: 100%;
  width: 100%;
}

</style>